import { TimelineItemTypes } from 'consts/timelineConsts'
import DateLabelTimelineItem from './DateLabelTimelineItem'
import GrinScanTimelineItem from './GrinScanTimelineItem'

export default {
  [TimelineItemTypes.Date]: DateLabelTimelineItem,
  [TimelineItemTypes.GrinScan]: GrinScanTimelineItem
}
